export default __webpack_public_path__ + "static/media/fc_icon_good.fb09cb05.svg";